import { createSlice } from '@reduxjs/toolkit';
import { CommunityState } from './state';
import reducers from './reducers';

const initialState: CommunityState = {
  communityList: null,
  post: null,
  event: null,
  notice: null,
  comments: [],
  notices: null,
  noticesFixed: null,
  events: null,
  branch_news: null,
  community_select_user: null,
  userPostList: null,
  branch_post: null,
  branch_event: null,
};

const community = createSlice({
  name: 'community',
  initialState,
  reducers,
});

export const communityActions = { ...community.actions };
export default community;
